module.exports = __webpack_public_path__ + "03_long_gray.07446a6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/03_long_gray.png
// module id = kYEM
// module chunks = 0